import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Box, Select,
  FormControl, InputLabel,MenuItem,Menu, ListItemIcon, ListItemText, Stack
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useAuth } from "../../../AuthProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FormHelperText from "@mui/material/FormHelperText";


import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { useLocation } from "react-router-dom";


const baseUrl=process.env.REACT_APP_API_BASE_URL
function BusFeesDetailsList() {
  const {oId,userId,userRoleName,role,board,pId}=useAuth();
const { state } = useLocation();
const principalId = state?.PrincipalId;
  const PrincipalId = pId || principalId;

  // const isAdmin = userId?.startsWith("ADM-") || false;
  const isAdmin = userId?.includes("ADM") || userRoleName?.startsWith("PRINCIPAL") || false;
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [busData, setBusData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  // console.log("fiterededata "+data.studentBusList);
  const [selectedBus, setSelectedBus] = useState("");
    const [selectedBusNoPlate, setSelectedBusNoPlate] = useState("");
  const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  // const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedStudentId, setSelectedStudentId]=useState("")
  const [errors, setErrors] = useState({});

  //SSC states
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  // const [sscSelectedSection, setSscSelectedSection] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");

  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  // const [interSelectedClass, setInterSelectedClass] = useState("");
  // const [interSelectedSection, setInterSelectedSection] = useState('');
  const [interSelectedClass, setInterSelectedClass] = useState("");
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");

  const [romanNumberClass, setRomanNumberClass] = useState("");
   const [dialogcourse, setDialogCourse] = useState("");

  const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
  console.log("selected mode :"+mode);
  const [sscClassSectionMap, setSscClassSectionMap] = useState({});
  const [hasFetchedOnce, setHasFetchedOnce] = useState(false); // new flag



   

  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
 
  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };
 
  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };
 
 const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState('');
  // const isPrincipal = role?.startsWith("PRINCIPAL") || false;
    const isPrincipal = role?.startsWith("PRINCIPAL") || role?.startsWith("ORGANIZATION") || false;
     
 const UserId = role === "ADMISSION_FEE" ? userId  : selectedUsers;

   const [transportusers, settransportUsers] = useState([]);
  const [selectedTransportUsers, setSelectedTransportUsers] = useState('');
const [villageOptions, setVillageOptions] = useState([]);
  const [selectedVillage, setSelectedVillage] = useState("");



const [editedData, setEditedData] = useState({
  grandTotal: "",
  // totalPaid: "",
  feeDue: "",
  payMethod: "",
  paymentDate: "",
  transactionId:'',
  paymentAmount: ""
});

  const handleAddNew = () => {
    navigate("/BusFeeRegistrationForm");
  };




    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${PrincipalId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

useEffect(() => {
  if (role === "PRINCIPAL" || role === "TRANSPORT" || role === "ORGANIZATION") {
    fetchUsers();
  }
}, [role]); // ✅ Run when `role` is available or changes


//     const fetchTransportUsers = async () => {
//         try {
//             const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${PrincipalId}`);
//             if (!response.ok) {
//                 throw new Error('Failed to fetch users');
//             }
//             const data = await response.json();
//             settransportUsers(data);
//             if (data.length > 0) {
//               setSelectedTransportUsers(data[0].userId); // ✅ Set first record's userId as default
//           }
//         } catch (error) {
//             console.error('Error fetching users:', error);
//         }
//     };

// useEffect(() => {
 
//     fetchTransportUsers();

// }, [oId,PrincipalId]); // ✅ Only runs on mount



  console.log("Filtered Data:", filteredData);
  useEffect(() => {
    const fetchData = async () => {
      if(!PrincipalId) return;
      try {
        const response = await fetch(`${baseUrl}/api/SchedulingRoute/bus-numbers/${PrincipalId}`);
                                             
        if (!response.ok) throw new Error("Failed to fetch bus numbers");
 
        const data = await response.json();
        console.log("Fetched Bus Numbers:", data);
        // setBusData(data || []);
 
        // if (data.length > 0) {
        //   setSelectedBus(data[0]); // Default to first bus number
        //     setSscSelectedClass("");
        // }

        setBusData(data || []);
          if (data.length > 0) {
            setSelectedBus(data[0].busNumber);
             setSelectedBusNoPlate(data[0].busNumberPlate); // store first object as default
            setSscSelectedClass("");
          }
      } catch (error) {
        console.error("Error fetching bus numbers:", error);
      }
    };
 
    fetchData();
  }, [oId,PrincipalId]); // Run only when `oId` changes
 
 

  //fetch students data with bus filter
  const fetchBusFeeDetails = async () => {
  if (!selectedBus) {
    setTableLoading(false);
    return;
  }

  setTableLoading(true);

  try {
    const response = await fetch(
      `${baseUrl}/api/busFee/adm/getAllStudentTransactions/${oId}/${UserId}?busNumber=${selectedBus}&rolePayment=bus_fee`
    );

    if (!response.ok) throw new Error("Failed to fetch transactions");

    const data = await response.json();
    console.log("Bus Fee Data:", data);

    const studentList = data.studentBusList || [];
    setFilteredData(studentList);

    // ✅ Correct village extraction
    const villages = [
      ...new Set(
        studentList
          .map(item => item.studentPickupLocation)
          .filter(Boolean)
      )
    ];

    setVillageOptions(villages);

  } catch (err) {
    console.error("Error fetching transactions:", err);
  } finally {
    setTableLoading(false);
  }
};

 
useEffect(() => {
  // Prevent API call if UserId is not available
  if (!UserId) return;

  fetchBusFeeDetails();
}, [selectedBus, oId, UserId]); // Re-fetch when `selectedBus` or `oId` changes


//fetch students data with bus filter with class, section

// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${PrincipalId}`);
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      // Group by class and merge section strings into unique values
      const classSectionMap = {};

      data.forEach(item => {
        const className = item.classRegistration;
        const sectionList = item.sections.split(",").map(s => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sectionList.forEach(section => classSectionMap[className].add(section));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes); // Class dropdown options
      setSscClassSectionMap(classSectionMap); // Save for section filtering later

      // No default selection
      setSscSelectedClass("");
      setSscSelectedSection("");
      setSscSectionOptions([]);
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};





// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if (!sscSelectedClass || !sscSelectedSection) {
    setFilteredData([]);
    // setOriginalData([]);
    setTableLoading(false);
    return;
  }
  setTableLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/busFee/adm/getAllStudentTransactionsWithClassAndSectionWise/${oId}/${UserId}?rolePayment=bus_fee&romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`
    );
    const data = await response.json();
    if (response.ok) {
      // setOriginalData(data);
      setFilteredData(data.studentBusList || []);
      // setFilteredData(data.feePayments || []);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      // setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setTableLoading(false);
  }
};




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${PrincipalId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      // if (!selectedCourseType) {
      //   setSelectedCourseType("");
      // }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----

const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    setInterSelectedSection("");
    return;
  }

  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${PrincipalId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections || "";
      const sections = sectionsString
        .split(",")
        .map((section) => section.trim());

      setInterSectionOptions(sections);
      setInterSelectedSection(sections[0] || "");
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE section data:", error);
    setInterSectionOptions([]);
    setInterSelectedSection("");
  }
};






// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setFilteredData([]);
    // setOriginalData([]);
    setTableLoading(false);
    return;
  }
  setTableLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/feePayment/adm/getAllfeePayments/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&rolePayment=tution_fee`
     
    );
    const data = await response.json();
    if (response.ok) {
      // setOriginalData(data);
      setFilteredData(data.feePayments || []);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      // setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
    setFilteredData([]);
  } finally {
    setTableLoading(false);
  }
};




useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchSectionsData();
  } else if (board === "SSC") {
    fetchClassRegistrationData();
  }
}, [board, interSelectedClass, selectedCourseType, oId]);

// SSC: When selected class changes, update its sections
// useEffect(() => {
//   const updateSectionOptions = async () => {
//     try {
//       const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}`);
//       const data = await response.json();
//       if (response.ok && Array.isArray(data)) {
//         const selectedClassData = data.find(item => item.classRegistration === sscSelectedClass);
//         if (selectedClassData) {
//           const sections = selectedClassData.sections.split(",");
//           setSscSectionOptions(sections);
//           setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
//         } else {
//           setSscSectionOptions([]);
//           setSscSelectedSection("");
//         }
//       }
//     } catch (error) {
//       console.error("Error updating SSC sections:", error);
//     }
//   };

//   if (board === "SSC" && sscSelectedClass) {
//     updateSectionOptions();
//   }
// }, [sscSelectedClass, board, oId]);

// INTERMEDIATE: When class or course type changes, update sections
useEffect(() => {
  const updateIntermediateSections = async () => {
    if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
      await fetchSectionsData();
    }
  };
  updateIntermediateSections();
}, [interSelectedClass, selectedCourseType, board]);



// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);

// Fetch Table Data whenever filters change
// useEffect(() => {
//   if (board === "SSC") {
//     if (!sscSelectedClass || !sscSelectedSection) {
//       setFilteredData([]);
//       setTableLoading(false); // ✅ stop loading even if API not called
//       return;
//     }
//     fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
//   } else if (board === "INTERMEDIATE") {
//     if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
//       setFilteredData([]);
//       setTableLoading(false); // ✅ same here
//       return;
//     }
//     fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
//   }
// }, [board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);

useEffect(() => {
  const fetchData = () => {
    if (board === "SSC") {
      if (sscSelectedClass && sscSelectedSection && mode === "classSection") {
        fetchClassSectionTableData();
      } else {
        setFilteredData([]);
        setTableLoading(false);
      }
    } else if (board === "INTERMEDIATE") {
      if (selectedCourseType && interSelectedClass && interSelectedSection && mode === "classSection") {
        fetchCourseClassSectionTableData();
      } else {
        setFilteredData([]);
        setTableLoading(false);
      }
    }
  };

  fetchData();
}, [board, sscSelectedClass, sscSelectedSection, selectedCourseType, interSelectedClass, interSelectedSection, mode]);




 
const handleEdit = (field, value) => {
  setEditedData((prev) => ({ ...prev, [field]: value }));
};


const handleSave = async () => {
  // Validate required fields
  let newErrors = {};

  if (!editedData.paymentDate) newErrors.paymentDate = "Payment Date is required";
  // if (!editedData.transactionId) newErrors.transactionId = "Transaction ID is required";
  if (!editedData.paymentAmount) newErrors.paymentAmount = "Amount to be Paid is required";
  if (!editedData.payMethod) newErrors.payMethod = "Payment Method is required";

  // If there are errors, set them and return early
  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  setLoading(true);
  const UserId = userId || selectedUsers;
  try {
    const formData = new FormData();
    Object.entries(editedData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const response = await fetch(
      `${baseUrl}/api/transaction/save/${selectedStudentId}/${UserId}/bus_fee/${editedData.romanNumberClass}/${editedData.sections}?sblId=${selectedRowData.id}`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`${errorText}` || "Failed to save data");
    }

    toast.success("Payment saved successfully!", { autoClose: 1000 });
   
    fetchClassSectionTableData();
     fetchBusFeeDetails();
  // ✅ Conditional logic to avoid fetchBusFeeDetails()
  // if (board === "INTERMEDIATE") {
  //   fetchCourseClassSectionTableData();
  // } else if (board === "SSC") {
  //   fetchClassSectionTableData();
  // } else {
  //   fetchBusFeeDetails(); // Only call if board is something else
  // }

    handleCloseDialog();

    setErrors({}); // Clear errors on successful submission
  } catch (error) {
    toast.error(`${error.message}` || "Error saving payment!", { autoClose: 2000 });
  } finally {
    setLoading(false);
  }
};




  const today = new Date().toISOString().split("T")[0];
  const handleViewClick = (row) => {
    setSelectedRowData(row);
    setSelectedStudentId(row.studentId);
    setEditedData({
      grandTotal: row.grandTotal || "",
      totalPaid: row.totalPaid || "",
      feeDue: row.feeDue || "",
      payMethod: "Cash", // Default value
      paymentDate: today, // Default empty
      transactionId:'',
      // fathersName:row.fathersName || "",
      studentFirstName:row.studentFirstName || "",
      studentLastName:row.studentLastName || "",
      romanNumberClass:row.romanNumberClass || "",
      sections:row.sections || ''
      // lastName:row.lastName || "",
     
    });
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     setFilteredData(filteredData);
  //     setLoading(false);
  //   }, 1000);
  // }, []);






  // Filter data based on searchQuery
  // const filteredResults = filteredData.filter((item) => {
  //   const studentFirstName = item.studentFirstName ? item.studentFirstName.toLowerCase() : "";
  //   const studentLastName = item.studentLastName ? item.studentLastName.toLowerCase() : "";
  //   const fullName = `${studentFirstName} ${studentLastName}`.trim(); // Combine first and last names
  //   const admissionNumber = item.customAdmissionNumber ? item.customAdmissionNumber.toString() : ""; // Ensure it's a string
 
  //   return (
  //     fullName.includes(searchQuery.toLowerCase()) || // Search in full name
  //     admissionNumber.includes(searchQuery) // Search in admission number
  //   );
  // });
 
const filteredResults = filteredData.filter((item) => {
  const studentFirstName = item.studentFirstName?.toLowerCase() || "";
  const studentLastName = item.studentLastName?.toLowerCase() || "";
  const fullName = `${studentFirstName} ${studentLastName}`;

  const matchesName = fullName.includes(searchQuery?.toLowerCase() || "");
  const matchesVillage = selectedVillage
    ? item.studentPickupLocation === selectedVillage
    : true;

  return matchesName && matchesVillage;
});





// const exportToExcel = () => {
//   const filteredData = filteredResults.map(
//     ({
//       customAdmissionNumber,
//       course,
//       romanNumberClass,
//       sections,
//       studentFirstName,
//       studentLastName,
//       gender,
//       busNumber,
//       routeNumber,
//       fatherPhoneNumber,
//       grandTotal,
//       totalPaid,
//       feeDue,
//     }) => ({
//       AdmissionNumber: customAdmissionNumber,
//       Course: course || "",
//       Class: romanNumberClass,
//       Section: sections,
//       StudentName: `${studentFirstName} ${studentLastName}`,
//       Gender: gender || "NA",
//       BusNumber: busNumber,
//       Route: routeNumber,
//       Phone: fatherPhoneNumber,
//       TotalFee: grandTotal,
//       PaidAmount: totalPaid,
//       DueAmount: feeDue,
//     })
//   );

//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet(`${selectedBus}_Bus Fee List`);

//   worksheet.columns = [
//     { header: "Admission No", key: "AdmissionNumber", width: 15 },
//     ...(board === "INTERMEDIATE" ? [{ header: "Course", key: "Course", width: 15 }] : []),
//     { header: board === "INTERMEDIATE" ? "Year" : "Class", key: "Class", width: 15 },
//     { header: "Section", key: "Section", width: 10 },
//     { header: "Student Name", key: "StudentName", width: 25 },
//     { header: "Gender", key: "Gender", width: 10 },
//     { header: "Bus No", key: "BusNumber", width: 10 },
//     { header: "Route", key: "Route", width: 10 },
//     { header: "Phone", key: "Phone", width: 15 },
//     { header: "Total Fee", key: "TotalFee", width: 15 },
//     { header: "Paid Amount", key: "PaidAmount", width: 15 },
//     { header: "Due Amount", key: "DueAmount", width: 15 },
//   ];

//   // Add student rows
//   filteredData.forEach((data) => {
//     const row = worksheet.addRow(data);
//     const paidCell = row.getCell("PaidAmount");
//     const dueCell = row.getCell("DueAmount");

//     paidCell.font = { color: { argb: "008000" }, bold: true }; // Green
//     if (data.DueAmount > 0) {
//       dueCell.font = { color: { argb: "FF0000" }, bold: true }; // Red
//     }
//   });

//   // Style the header row
//   worksheet.getRow(1).eachCell((cell) => {
//     cell.font = { bold: true };
//     cell.alignment = { horizontal: "center" };
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "87CEEB" }, // Light Blue
//     };
//   });

//   // Calculate totals
//   const totalFeeSum = filteredData.reduce((sum, item) => sum + (item.TotalFee || 0), 0);
//   const totalPaidSum = filteredData.reduce((sum, item) => sum + (item.PaidAmount || 0), 0);
//   const totalDueSum = filteredData.reduce((sum, item) => sum + (item.DueAmount || 0), 0);

//   // Optional: add a blank row before total
//   worksheet.addRow({});

//   // Add total row
//   const totalRow = worksheet.addRow({
//     AdmissionNumber: "Total Amount",
//     TotalFee: `₹${totalFeeSum.toLocaleString("en-IN")}`,
//     PaidAmount: `₹${totalPaidSum.toLocaleString("en-IN")}`,
//     DueAmount: `₹${totalDueSum.toLocaleString("en-IN")}`,
//   });

//   // Merge for label (A to I)
//   worksheet.mergeCells(`A${totalRow.number}:I${totalRow.number}`);

//   // Style the total row
//   totalRow.eachCell((cell) => {
//     cell.font = { bold: true };
//     cell.alignment = { horizontal: "center" };
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "FFF9C4" }, // Light Yellow
//     };
//   });

//   // Export Excel file
//   workbook.xlsx.writeBuffer().then((buffer) => {
//     const blob = new Blob([buffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = `${selectedBus}_BusFeeList.xlsx`;
//     link.click();
//   });

//   handleExportClose();
// };


// Export to PDF


const    exportToExcel = () => {
  const filteredData = filteredResults.map(
    ({
      customAdmissionNumber,
      course,
      romanNumberClass,
      sections,
      studentFirstName,
      studentLastName,
      gender,
      busNumberPlate,
      routeNumber,
      studentPickupLocation,
      grandTotal,
      totalPaid,
      feeDue,
    }) => ({
      AdmissionNumber: customAdmissionNumber,
      Course: course || "",
      Class: romanNumberClass,
      Section: sections,
      StudentName: `${studentFirstName} ${studentLastName}`,
      Gender: gender || "NA",
      BusNumber: busNumberPlate,
      Route: routeNumber,
      Phone: studentPickupLocation,
      TotalFee: Number(String(grandTotal).replace(/,/g, "")) || 0,
      PaidAmount: Number(String(totalPaid).replace(/,/g, "")) || 0,
      DueAmount: Number(String(feeDue).replace(/,/g, "")) || 0,
    })
  );

  const workbook = new ExcelJS.Workbook();
  // const worksheet = workbook.addWorksheet(`${selectedBus}_Bus Fee List`);

  const worksheet = workbook.addWorksheet(
            (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
              ? `${interSelectedClass}-${interSelectedSection}_Bus Fee List`
              : (board === "SSC" && sscSelectedClass && sscSelectedSection)
                ? `${sscSelectedClass}-${sscSelectedSection}_Bus Fee List`
                : `${selectedBusNoPlate}_Bus Fee List`
          );

  worksheet.columns = [
    { header: "Admission No", key: "AdmissionNumber", width: 15 },
    ...(board === "INTERMEDIATE" ? [{ header: "Course", key: "Course", width: 15 }] : []),
    { header: board === "INTERMEDIATE" ? "Year" : "Class", key: "Class", width: 15 },
    { header: "Section", key: "Section", width: 10 },
    { header: "Student Name", key: "StudentName", width: 25 },
    { header: "Gender", key: "Gender", width: 10 },
    { header: "Bus No", key: "BusNumber", width: 20 },
    { header: "Route", key: "Route", width: 10 },
    { header: "Village Name", key: "Phone", width: 15 },
    { header: "Total Fee", key: "TotalFee", width: 15 },
    { header: "Paid Amount", key: "PaidAmount", width: 15 },
    { header: "Due Amount", key: "DueAmount", width: 15 },
  ];

  // Add student rows
  filteredData.forEach((data) => {
    const row = worksheet.addRow(data);
    const paidCell = row.getCell("PaidAmount");
    const dueCell = row.getCell("DueAmount");

    paidCell.font = { color: { argb: "008000" }, bold: true }; // Green
    if (data.DueAmount > 0) {
      dueCell.font = { color: { argb: "FF0000" }, bold: true }; // Red
    }
  });

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light blue
    };
  });

  // Calculate totals
  const totalFeeSum = filteredData.reduce((sum, item) => sum + (item.TotalFee || 0), 0);
  const totalPaidSum = filteredData.reduce((sum, item) => sum + (item.PaidAmount || 0), 0);
  const totalDueSum = filteredData.reduce((sum, item) => sum + (item.DueAmount || 0), 0);

  // Add empty row before total
  worksheet.addRow({});

  // Add total row
  const totalRow = worksheet.addRow({
    AdmissionNumber: "Total Amount",
    TotalFee: totalFeeSum,
    PaidAmount: totalPaidSum,
    DueAmount: totalDueSum,
  });

  // Merge label across columns (A to I)
  worksheet.mergeCells(`A${totalRow.number}:H${totalRow.number}`);

  // Format total cells as currency
  ["TotalFee", "PaidAmount", "DueAmount"].forEach((key) => {
    const cell = totalRow.getCell(key);
    cell.numFmt = '₹#,##0';
  });

  // Style the total row
  totalRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFF9C4" }, // Light Yellow
    };
  });

  // Export file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    // link.download = `${selectedBus}_BusFeeList.xlsx`;

     link.download =
  board === "INTERMEDIATE" && interSelectedClass && interSelectedSection
    ? `${interSelectedClass}-${interSelectedSection}_BusFeeList.xlsx`
    : board === "SSC" && sscSelectedClass && sscSelectedSection
    ? `${sscSelectedClass}-${sscSelectedSection}_BusFeeList.xlsx`
    : `${selectedBusNoPlate}_BusFeeList.xlsx`;


    link.click();
  });

  handleExportClose();
};

const exportToPDF = () => {
  const doc = new jsPDF();

  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");

  // Dynamic title
  if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
    doc.text(`${interSelectedClass}-${interSelectedSection} Bus Fee List`, 10, 8);
  } else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
    doc.text(`${sscSelectedClass}-${sscSelectedSection} Bus Fee List`, 10, 8);
  } else {
    doc.text(`${selectedBusNoPlate} - Bus Fee List`, 10, 8);
  }

  // Generated date
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On: ", 10, 16);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 35, 16);

  // Headers
  const headers =
    board === "INTERMEDIATE"
      ? [
          "S.No",
          "Admission No",
          "Course",
          "Year",
          "Section",
          "Student Name",
          // "Gender",
          "Bus No",
          // "Route",
          "Village Name",
          "Total",
          "Paid",
          "Due",
        ]
      : [
          "S.No",
          "Admission No",
          "Class",
          "Section",
          "Student Name",
          // "Gender",
          "Bus No",
          // "Route",
          "Village Name",
          "Total",
          "Paid",
          "Due",
        ];

  // Data rows
  const body = filteredResults.map((row, index) => {
    const rowData = [index + 1, row.customAdmissionNumber];

    if (board === "INTERMEDIATE") {
      rowData.push(row.course);
    }

    rowData.push(
      row.romanNumberClass,
      row.sections,
      `${row.studentFirstName} ${row.studentLastName}`,
      // row.gender || "N/A",
      row.busNumberPlate,
      // row.routeNumber,
      row.studentPickupLocation,
      row.grandTotal,
      { content: row.totalPaid, styles: { textColor: [0, 128, 0], fontStyle: "bold" } }, // green
      { content: row.feeDue, styles: { textColor: [255, 0, 0], fontStyle: "bold" } } // red
    );

    return rowData;
  });

  // Totals
  const totalFeeSum = filteredResults.reduce(
    (sum, item) => sum + (Number(String(item.grandTotal).replace(/,/g, "")) || 0),
    0
  );
  const totalPaidSum = filteredResults.reduce(
    (sum, item) => sum + (Number(String(item.totalPaid).replace(/,/g, "")) || 0),
    0
  );
  const totalDueSum = filteredResults.reduce(
    (sum, item) => sum + (Number(String(item.feeDue).replace(/,/g, "")) || 0),
    0
  );

  // Add total row
  const totalRow = [
    { content: "Total Amount", colSpan: headers.length - 3, styles: { halign: "right", fontStyle: "bold" } },
    totalFeeSum,
    { content: totalPaidSum, styles: { textColor: [0, 128, 0], fontStyle: "bold" } },
    { content: totalDueSum, styles: { textColor: [255, 0, 0], fontStyle: "bold" } },
  ];

  // Table
  doc.autoTable({
    startY: 20,
    head: [headers],
    body: [...body, totalRow],
     margin: { top: 0, left: 3, right: 3 },
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  // Dynamic filename
  if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
    doc.save(`${interSelectedClass}-${interSelectedSection}_BusFeeList.pdf`);
  } else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
    doc.save(`${sscSelectedClass}-${sscSelectedSection}_BusFeeList.pdf`);
  } else {
    doc.save(`${selectedBusNoPlate}_BusFeeList.pdf`);
  }

  handleExportClose();
};

// Export to JSON
const exportToJSON = () => {
  const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(filteredResults, null, 2)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  link.download = `${selectedBus}_BusFeeList.json`;
  link.click();
  handleExportClose();
};

  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <CardContent>
        {/* Title Section */}
         <Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              All Students Bus Fee Details
                              </Typography>
                            </Box>

        {/* Search and Add New Button Section */}
<Grid
  container
  spacing={2}
  alignItems="center"
  wrap="nowrap"
  style={{
    marginTop: "8px",
    overflowX: "auto",
    flexWrap: "nowrap",
  }}
>
  {/* All Filters */}
  <Grid
    item
    xs
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
      whiteSpace: "nowrap",
    }}
  >
    {/* Search Field */}
    <TextField
      label="Search by Admission No or Name"
      variant="outlined"
      size="small"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      sx={{ width: "200px" }}
    />

    {/* Select Bus */}
    <FormControl sx={{ width: 180 }} size="small">
      <InputLabel id="bus-select-label">Select Bus</InputLabel>
      <Select
        labelId="bus-select-label"
        value={selectedBus}
        // onChange={(e) => setSelectedBus(e.target.value)}
 onChange={(e) => {
  // setSelectedBus(e.target.value);
    const value = e.target.value;
      setSelectedBus(value);
  // ✅ find bus object by busNumber
      const selected = busData.find((b) => b.busNumber === value);
      if (selected) {
        setSelectedBusNoPlate(selected.busNumberPlate || selectedBusNoPlate);
      }
       setSelectedVillage("");
  setSscSelectedClass("");
  setSscSelectedSection("")
}}
        label="Select Bus"
      >
        {busData.map((bus, index) => (
          <MenuItem key={index} value={bus.busNumber}>
      {bus.busNumberPlate}
    </MenuItem>
        ))}
      </Select>
    </FormControl>

     {/*select village*/}
                <FormControl style={{ width: "150px" }} variant="outlined" size="small">
      <InputLabel id="village-select-label" style={{ fontSize: "12px" }}>
        Select Village
      </InputLabel>
      <Select
        labelId="village-select-label"
        value={selectedVillage}
        onChange={(e) => setSelectedVillage(e.target.value)}
        label="Select Village"
        style={{ height: "35px", fontSize: "13px" }}
      >
        <MenuItem value="">
          <em>All Villages</em>
        </MenuItem>
    
        {villageOptions.map((village, index) => (
          <MenuItem key={index} value={village}>
            {village}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    {/* SSC Filters */}
    {board === "SSC" && (
      <>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="class-select-label">Select Class</InputLabel>
          <Select
            labelId="class-select-label"
            value={sscSelectedClass}
            onChange={(e) => {
              const selected = e.target.value;
              setSscSelectedClass(selected);
              setMode("classSection");
              setSelectedBus("");
               setSelectedVillage("");
              const sections = sscClassSectionMap[selected]
                ? Array.from(sscClassSectionMap[selected])
                : [];
              setSscSectionOptions(sections);
              setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
            }}
            label="Select Class"
            sx={{ height: 35 }}
          >
            {sscClassOptions.map((cls) => (
              <MenuItem key={cls} value={cls}>
                {cls}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="section-select-label">Select Section</InputLabel>
          <Select
            labelId="section-select-label"
            value={sscSelectedSection}
            onChange={(e) => {
              setSscSelectedSection(e.target.value);
              setMode("classSection");
            }}
            label="Select Section"
            sx={{ height: 35 }}
          >
            {sscSectionOptions.length === 0 ? (
              <MenuItem value="" disabled>
                Select Class
              </MenuItem>
            ) : (
              sscSectionOptions.map((section) => (
                <MenuItem key={section} value={section}>
                  {section}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </>
    )}

    {/* INTERMEDIATE Filters */}
    {board === "INTERMEDIATE" && (
      <>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
          <Select
            labelId="intermediate-class-select-label"
            value={interSelectedClass}
            onChange={(e) => setInterSelectedClass(e.target.value)}
            label="Select Year"
            sx={{ height: 35 }}
          >
            <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
            <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="course-type-label">Select Course</InputLabel>
          <Select
            labelId="course-type-label"
            value={selectedCourseType}
            onChange={(e) => {
              setSelectedCourseType(e.target.value);
              setMode("classSection");
            }}
            label="Select Course"
            sx={{ height: 35 }}
          >
            {courseOptions.map((course, index) => (
              <MenuItem key={index} value={course}>
                {course}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
          <Select
            labelId="intermediate-section-select-label"
            value={interSelectedSection || ""}
            onChange={(e) => {
              setInterSelectedSection(e.target.value);
              setMode("classSection");
            }}
            label="Select Section"
            sx={{ height: 35 }}
          >
            {interSectionOptions.length === 0 ? (
              <MenuItem value="" disabled>
                Select Year and Course
              </MenuItem>
            ) : (
              interSectionOptions.map((section, index) => (
                <MenuItem key={index} value={section}>
                  {section}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </>
    )}
  </Grid>

  {/* Export Button */}
  <Grid item xs="auto">
    <Button
      variant="contained"
      onClick={handleExportClick}
      style={{ backgroundColor: "#3C3972", fontWeight: "bold" }}
      startIcon={<PresentToAllIcon />}
    >
      Export
    </Button>

    <Menu
      anchorEl={exportAnchorEl}
      open={isExportMenuOpen}
      onClose={handleExportClose}
      sx={{
        "& .MuiPaper-root": {
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
        },
      }}
    >
      <MenuItem
        onClick={exportToExcel}
        sx={{
          color: "#3f51b5",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "#e8f0fe",
          },
        }}
      >
        <ListItemIcon sx={{ color: "#00796b" }}>
          <SimCardDownloadIcon />
        </ListItemIcon>
        <ListItemText primary="Excel" sx={{ fontWeight: "bold", color: "#00796b" }} />
      </MenuItem>

      <MenuItem
        onClick={exportToPDF}
        sx={{
          color: "#d32f2f",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "#fdecea",
          },
        }}
      >
        <ListItemIcon sx={{ color: "#d32f2f" }}>
          <PictureAsPdfIcon />
        </ListItemIcon>
        <ListItemText primary="PDF" sx={{ fontWeight: "bold", color: "#d32f2f" }} />
      </MenuItem>
    </Menu>
  </Grid>
</Grid>


<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />
        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px' }}>S.No</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px' }}>Admission No</TableCell>
                {(board === "INTERMEDIATE" ) && (
                                                                                            <TableCell
                                                                                                                                                                                  sx={{
                                                                                                                                                                                    borderRight: "1px solid #ddd",
                                                                                                                                                                                    padding: "4px",
                                                                                                                                                                                    textAlign: "center",
                                                                                                                                                                                    whiteSpace: "nowrap",
                                                                                                                                                                                    backgroundColor: "#fff9c4",
                                                                                                                                                                                    overflow: "hidden",
                                                                                                                                                                                    textOverflow: "ellipsis",
                                                                                                                                                                                    fontSize: "14px",
                                                                                                                                                                                    fontWeight: "bold",
                                                                                                                                                                                  }}
                                                                                                                                                                                  >
                                                                                                                                                                                    Course
                                                                                             </TableCell>
                 )}
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>{board === "INTERMEDIATE" ? "Year" : "Class"}</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Section</TableCell>
               
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Name</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Gender</TableCell> */}
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Bus No</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Route</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Pickup</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Drop</TableCell> */}
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Village Name</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Amount</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Paid Amount</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Due Amount</TableCell>
                {isAdmin && ( // Show these only for Admin users
                  <>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Payments</TableCell>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Transactions</TableCell>  
                  </>
                )}

                 
                   
                {/* <TableCell sx={{ padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Action</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {tableLoading ? (
                <TableRow>
                  <TableCell colSpan={15} style={{ textAlign: "center", padding: "20px" }}>
                                                    <Box display="flex" flexDirection="column" alignItems="center">
                                                    <CircularProgress />
                                                    <Typography variant="body2" sx={{ mt: 1 }}>
                                                      Loading Data...
                                                    </Typography>
                                                  </Box>
                                                </TableCell>
                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={15} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow key={row.id} style={{
                    backgroundColor: "white",
                    transition: "background-color 0.3s",
                    height: "40px",  // Reduced row height
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "white"; // Default color
                  }}>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{index + 1}</TableCell>

                   
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.customAdmissionNumber}</TableCell>
                    {board === "INTERMEDIATE" && (
                                                                                                                                                            <TableCell
                                                                                                                                                              sx={{
                                                                                                                                                                borderRight: "1px solid #ddd",
                                                                                                                                                                padding: "4px",
                                                                                                                                                                textAlign: "center",
                                                                                                                                                              }}
                                                                                                                                                            >
                                                                                                                                                              {row.course}
                                                                                                                                                            </TableCell>
                    )}
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.romanNumberClass}</TableCell>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.sections}</TableCell>
                   
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.studentFirstName} {row.studentLastName}</TableCell>
                    {/* <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.gender}</TableCell> */}
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.busNumberPlate}</TableCell>
                    {/* <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.routeNumber}</TableCell>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.studentPickupLocation}</TableCell>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.studentDropLocation}</TableCell> */}
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.studentPickupLocation}</TableCell>
                 
                    {/* <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>₹{row.grandTotal}</TableCell> */}
                        <TableCell
                                          sx={{
                                            borderRight: "1px solid #ddd",
                                            padding: "2px",
                                            textAlign: "center",
                                          }}
                                        >
                                          <Button
                                            variant="contained"
                                            style={{
                                              backgroundColor: "#FFA500", // Orange tone for concession
                                              color: "#fff",
                                              fontWeight: "bold",
                                              textTransform: "none",
                                              borderRadius: "20px",
                                            }}
                                          >
                                            ₹{row.grandTotal}
                                          </Button>
                                        </TableCell>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
                      <Button
                        variant="contained"
                        color="success"
                        style={{
                          backgroundColor:  "#65C63E",
                          color: "#fff",
                          fontWeight: "bold",
                          textTransform: "none",
                          borderRadius: "20px",
                        }}
                      >
                        ₹{row.totalPaid} {/* Paid amount displayed as light green button */}
                      </Button>
                    </TableCell>
                   
                   
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
  {row.feeDue === 0 ? (
    <span style={{ fontWeight: "bold", color: "green" }}>No Due Amount</span> // ✅ Display text when feeDue is 0
  ) : (
    <Button
      variant="outlined"
      color="error"
      style={{
        backgroundColor: "#ED3638",
        color: "#fff",
        fontWeight: "bold",
        textTransform: "none",
        borderRadius: "20px",
      }}
    >
      ₹{row.feeDue} {/* ✅ Show due amount when feeDue is not 0 */}
    </Button>
  )}
</TableCell>

{isAdmin && ( // Show these only for Admin users
                  <>
                      <TableCell
                                  sx={{
                                    borderRight: "1px solid #ddd",
                                    padding: "4px",
                                    textAlign: "center",
                                  }}
                                >
                            

<Button
        type="button"
        onClick={() => handleViewClick(row)} // Open dialog with the row data
        disabled={row.feeDue === 0} // ✅ Disable when feeDue is 0
        sx={{
          backgroundColor: row.feeDue === 0 ? "#ccc" : "#1976d2", // Gray background when disabled
          color: "white",
          fontSize: "0.7rem",
          height: "25px",
          "&:hover": {
            backgroundColor: row.feeDue === 0 ? "#ccc" : "#1565c0",
          },
        }}
      >
        Payments
      </Button>
                                </TableCell>

                                 <TableCell
                                                      sx={{
                                                        borderRight: "1px solid #ddd",
                                                        padding: "4px",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                     
                                                      <Button
                                                              type="button"
                                                              // onClick={() => navigate(`/BusFeeTransactionList/${row.admissionNumber}`)} // Open dialog with the row data
                                                               onClick={() => navigate(`/StudentPaymentsTransactionList/${row.admissionNumber}/${row.rolePayment}`)}
                                                              disabled={row.totalPaid === 0} // ✅ Disable when feeDue is 0
                                                              sx={{
                                                                backgroundColor: row.totalPaid === 0 ? "#ccc" : "#1976d2", // Gray background when disabled
                                                                color: "white",
                                                                fontSize: "0.7rem",
                                                                height: "25px",
                                                                "&:hover": {
                                                                  backgroundColor: row.totalPaid === 0 ? "#ccc" : "#1565c0",
                                                                },
                                                              }}
                                                            >
                                                              View
                                                            </Button>
                                                    </TableCell>
                  </>
                )}  

                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

              {/* Dialog Box */}
              <Dialog open={dialogOpen} onClose={handleCloseDialog} fullWidth maxWidth="sm" sx={{ borderRadius: 3 }}>
  <DialogTitle sx={{ fontWeight: "bold", textAlign: "center", bgcolor: "#1976d2", color: "white", py: 2, borderTopLeftRadius: 3, borderTopRightRadius: 3 }}>Bus Fee Payment</DialogTitle>
  <DialogContent>
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: "20px" }}>
    <div style={{ display: "flex", width: "100%" }}>
      <div style={{ display: "flex", width: "100%" }}>
                <span style={{ fontWeight: "bold" ,paddingRight:'10px'}}>Student Name:</span>
                <span>{editedData.studentFirstName} {editedData.studentLastName}</span>
              </div>
              {/* <div style={{ display: "flex", width: "100%" }}>
                <span style={{ fontWeight: "bold" ,paddingRight:'15px'}}>Father Name:</span>
                <span>{editedData.fathersName}</span>
              </div> */}
              </div>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField label="Total Fee" variant="outlined" value={`₹${editedData.grandTotal}`} fullWidth size="small" disabled
                InputProps={{
                  style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
                }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField label="Paid Amount" variant="outlined" value={`₹${editedData.totalPaid || "No Paid Amount"}`} fullWidth size="small"
          disabled
      InputProps={{
        style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
      }} />
        </Grid>
     
     
        <Grid item xs={6}>
          <TextField label="Due Amount" variant="outlined" value={`₹${editedData.feeDue || "No Fee Due Amount"}`} fullWidth size="small" disabled
      InputProps={{
        style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
      }} />
        </Grid>

                      <Grid item xs={6}>
  <TextField
    label="Payment Date"
    variant="outlined"
    type="date"
    value={editedData.paymentDate }
    onChange={(e) =>
      handleEdit("paymentDate", e.target.value)
    }
    fullWidth
    size="small"
    InputLabelProps={{ shrink: true }}
    inputProps={{
      max: new Date().toISOString().split("T")[0], // ✅ No future dates
    }}
  />
</Grid>


<Grid item xs={6}>
  
  <TextField
    label="Amount to be Paid"
    variant="outlined"
    type="text"
    value={editedData.paymentAmount}
    placeholder="Enter Amount"
    onKeyDown={(e) => {
      // Allow only digits and control keys like Backspace, Delete, Arrow keys
      const allowedKeys = [
        "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"
      ];
      if (
        !/^\d$/.test(e.key) && // if not a digit
        !allowedKeys.includes(e.key)
      ) {
        e.preventDefault(); // Block the key press
      }
    }}
    onChange={(e) => {
      const val = e.target.value;
      if (/^\d*$/.test(val)) {
        handleEdit("paymentAmount", val);
        setErrors({ ...errors, paymentAmount: "" });
      }
    }}
    fullWidth
    size="small"
    error={!!errors.paymentAmount}
    helperText={errors.paymentAmount}
    inputProps={{
      inputMode: "numeric",
      maxLength: 10,
    }}
  />
</Grid>


        <Grid item xs={6}>
  <TextField
    label="Transaction Id"
    variant="outlined"
    value={editedData.transactionId}
    onChange={(e) => {
      handleEdit("transactionId", e.target.value);
      // setErrors({ ...errors, transactionId: "" });
    }}
    fullWidth
    size="small"
    // error={!!errors.transactionId}
    // helperText={errors.transactionId}
  />
</Grid>
        

<Grid item xs={6}>
  <FormControl fullWidth size="small"
  error={!!errors.payMethod}
  >
    <InputLabel>Payment Method</InputLabel>
    <Select
      value={editedData.payMethod}
      onChange={(e) => {
        handleEdit("payMethod", e.target.value);
        setErrors({ ...errors, payMethod: "" });
      }}
      label="Payment Method"
    >
      <MenuItem value="Cash">Cash</MenuItem>
      <MenuItem value="Credit">Credit Card</MenuItem>
      <MenuItem value="Debit">Debit</MenuItem>
      <MenuItem value="Online">Online</MenuItem>
    </Select>
    {errors.payMethod && <FormHelperText>{errors.payMethod}</FormHelperText>}
  </FormControl>
</Grid>

      </Grid>
    </Box>
  </DialogContent>
  <DialogActions sx={{ justifyContent: "flex-end", pt: 0.5, pb: 1, pr: 2 }}>
    <Button onClick={handleCloseDialog} color="primary" variant="outlined">Cancel</Button>
    <Button
  onClick={handleSave}
  color="success"
  variant="outlined"
  sx={{
    backgroundColor: "#3C3972",
    color: "white",
    fontSize: "0.8rem",
    height: "35px",
    minWidth: "80px", // Ensures consistent button size
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#3C3972",
    },
  }}
  disabled={loading} // Disable button while loading
>
  {loading ? <CircularProgress size={20} sx={{ color: "white" }} /> : "Save"}
</Button>

  </DialogActions>
              </Dialog>

              <ToastContainer position="top-right" autoClose={1000} />

      </CardContent>
    </Card>
  );
}

export default BusFeesDetailsList;